











































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { clearEmptyAttr } from "@root/utiles/common";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";

const root = namespace("root");
const common = namespace("common");
const storeManage = namespace("storeManage");

@Component({})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class StoreManageKA extends Vue {
  @root.State ddCodes;
  @common.State wtDicCodes;
  @common.Action getDict;
  @storeManage.Action getK1CustomerManagePageRest: Function;
  @storeManage.Action exportKaStoreRest: Function;

  private dataList: any[] = [];
  private brandOptions: any[] = [];
  private districtOptions: any[] = [];
  private branchOptions: any[] = [];
  gtExportDialog = false;
  exportParams: any = {};

  tabListOptions: any[] = [
    { value: "", label: "全部" },
    { value: 0, label: "启用" },
    { value: 1, label: "禁用" }
  ];

  // 搜索参数
  private form: any = {
    storeCode: "",
    storeSignBrand: "",
    district: "",
    branch: "",
    state: "",
    storeClass: "KA"
  };

  async created() {
    await Promise.all([this.getBrandData(), this.getDistrictData()]);
  }

  async mounted() {
    this.getData();
  }

  // 获取店招品牌数据
  async getBrandData() {
    await this.getDict({ dictCodes: ["STORE_SIGN_BRAND"] });
    const brandList = this.wtDicCodes["STORE_SIGN_BRAND"] || [];
    this.brandOptions = brandList.map((_: any) => ({
      label: _.dictDesc,
      value: _.dictValue
    }));
  }

  // 获取区域和分部数据
  async getDistrictData() {
    await this.$dd.register(["DISTRICT_CODE", "SUBSECTION_CODE"]).query();
    this.districtOptions = this.ddCodes["DISTRICT_CODE"] || [];
    this.branchOptions = this.ddCodes["SUBSECTION_CODE"] || [];
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    try {
      const res = await this.getK1CustomerManagePageRest({
        pageSize,
        pageNum,
        ...this.form
      });
    this.exportParams = {...this.form};
      this.dataList = res.list || [];
      (this as any).total = res.total || 0;
    } catch (e) {
      console.log(e);
    }
  }

  tabToggleHandle(tab: any) {
    this.form.state = tab ? +tab : "";
    this.getData();
  }

  toDetail(row: any) {
    this.$router.push({
      name: "storeMgDetail",
      query: { code: row.storeCode }
    });
  }

  async handleExport() {
    // this.exportParams = clearEmptyAttr(this.form);
    this.gtExportDialog = true;
  }
}
